module.exports = __webpack_public_path__ + "img/steps.8d1f7884.svg";